import { NumericFormat } from 'react-number-format';
import * as setup from 'setup';
import styled from 'styled-components';

export const FunnelInputElement = styled(NumericFormat as any) <FunnelInputElementProps>`
    max-width: 90%;
    & > input {
        border-radius: 5px;
        border: none;
        color: ${setup.colors.black};
        font-family: inherit;
        font-size: ${({ $size }) => $size}px;
        font-weight: bold;
        max-height: 20px;
        max-width: 100%;
        min-width: 30px;
        outline: none;
        padding: 3px;
        text-align: center;
        &::placeholder {
            color: ${setup.colors.black};
            font-weight: normal;
        }
        &:hover, &:focus {
            background: ${setup.colors.primary};
        }
        &:disabled {
            background: transparent;
            color: ${setup.colors.black};
            font-weight: bold;
        }
    }
`;